import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BoelsPointOfService } from '@boels/models';
import { JsonLdBuilder } from '../../structured-data.model';

type WeekDay = {
  '@type': string;
  opens?: string;
  closes?: string;
  dayOfWeek?: string;
};
@Injectable()
export class JsonldLocalBusinessOpeningTimesBuilder
  implements JsonLdBuilder<BoelsPointOfService>
{
  build(pointOfService: BoelsPointOfService): Observable<any> {
    if (!pointOfService.openingHours?.weekDayOpeningList) {
      return of({});
    }

    const schema: WeekDay[] = [];
    const MIDNIGHT = '00:00';

    for (const openingTime of pointOfService.openingHours.weekDayOpeningList) {
      const weekDay: WeekDay = { '@type': 'OpeningHoursSpecification' };
      if (openingTime.openingTime) {
        weekDay.opens = openingTime.openingTime.formattedHour;
        if (openingTime.openingTime2) {
          weekDay.opens += ` & ${openingTime.openingTime2.formattedHour}`;
        }
      }
      if (openingTime.closingTime) {
        weekDay.closes = openingTime.closingTime.formattedHour;
        if (openingTime.closingTime2) {
          weekDay.closes += ` & ${openingTime.closingTime2.formattedHour}`;
        }
      }

      if (openingTime?.closed) {
        weekDay.opens = MIDNIGHT;
        weekDay.closes = MIDNIGHT;
      }
      if (openingTime.weekDayQualified) {
        weekDay.dayOfWeek = openingTime.weekDayQualified;
      }

      if (weekDay.opens || weekDay.closes || weekDay.dayOfWeek) {
        // filter all elements that have none of the data
        schema.push(weekDay);
      }
    }

    return of({ openingHoursSpecification: schema });
  }
}
